var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tk-flex',{staticClass:"w-full h-full bg-white",attrs:{"middle":"","column":"","center":""}},[_c('tk-image',{attrs:{"src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }